import { render } from "./AppAccordion.vue?vue&type=template&id=32c1ad5b&scoped=true"
import script from "./AppAccordion.vue?vue&type=script&lang=js"
export * from "./AppAccordion.vue?vue&type=script&lang=js"

import "./AppAccordion.vue?vue&type=style&index=0&id=32c1ad5b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c1ad5b"]])

export default __exports__